/* eslint-disable react/jsx-no-target-blank */
import { FC } from "react";



import { PaciraLogo } from "../../assets";

import { FooterTextProps } from "./types";



const FooterText: FC<FooterTextProps> = ({ footerType }): JSX.Element => {

  return (
      <div className="reserved-text">
          <div className="container">
              <p className="text-white">
                  For more information on iovera, visit <a className={"fw-bold"} href="https://www.ioverapro.com/" target="_blank"> ioverapro.com </a>
                  or call 1-855-793-9727. For more information on ZILRETTA, visit
                  <a className={"fw-bold"} href="https://zilrettapro.com/" target="_blank"> www.zilrettapro.com </a>
                  or call 1-855-793-9727. You are encouraged to report negative side effects of prescription drugs to FDA; visit
                  <a className={"fw-bold"} href="http://www.fda.gov/medwatch" target="_blank"> www.fda.gov/medwatch </a>
                  or call 1-800-FDA-1088.
              </p>
              <div className="row">
                  <div className="col-sm-2"><img className="img-fluid pacira-logo" src={PaciraLogo} alt="Pacira Logo"/></div>
                  <div className="col-sm-10">
                      <p className="text-white">
                          © 2025 Pacira Pharmaceuticals, Inc., a wholly owned subsidiary of Pacira BioSciences, Inc. ZILRETTA and
                          FlexForward are registered trademarks of Pacira Therapeutics, Inc., and iovera° is a registered trademark
                          of Pacira CryoTech, Inc., both of which are wholly owned subsidiaries of Pacira BioSciences, Inc.
                          PP-MP-US-0346 January 2026
                      </p>
                  </div>
              </div>
          </div>
      </div>
  );
};

export default FooterText;
